import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  featured_seller: PropTypes.shape({
    favourite_brand: PropTypes.shape({
      hero_image_url: PropTypes.string
    }),
    inspired_look_thumbnail_image_url : PropTypes.string,
    main_page_thumbnail_image_url     : PropTypes.string
  })
}

const defaultProps = {
  featured_seller: {
    favourite_brand: {
      hero_image_url: ''
    }
  },
  inspired_look_thumbnail_image_url : '',
  main_page_thumbnail_image_url     : ''

}

/**
 * Layout to preview CMS Featured Seller in create-and-edit page
 */

function CmsFeaturedSellerFavouriteBrandPreviewSection({
  featured_seller
}) {
  return (
    <Card>
      <CardHeader>
        <h2>PREVIEW</h2>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg='12' style={{ backgroundColor: 'gray' }}>
            <h3 className='text-center'>Header</h3>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='12' className='p-0' style={{ minHeight: '150px', backgroundColor: 'aqua', textAlign: 'center' }}>
            {
              featured_seller.favourite_brand.hero_image_url ?
                <img src={ `${featured_seller.favourite_brand.hero_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '55px' }}>Cover Image</h3>
            }
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='4' style={{ height: '450px', backgroundColor: '#808080b8' }}>
            <h3 className='text-center' style={{ paddingTop: '225px' }}>Product Filter</h3>
          </Col>
          <Col lg='8' style={{ height: '450px', backgroundColor: '#80808082' }}>
            <h3 className='text-center' style={{ paddingTop: '225px' }}>Product List</h3>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='6' className='p-0' style={{  minHeight: '100px', backgroundColor: 'aqua' }}>
            {
              featured_seller.main_page_thumbnail_image_url ?
                <img src={ `${featured_seller.main_page_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '25px' }}>Main Page Thumbnail Image</h3>
            }
          </Col>
          <Col lg='6' className='p-0' style={{ minHeight: '100px', backgroundColor: '#00ff4e' }}>
            {
              featured_seller.inspired_look_thumbnail_image_url ?
                <img src={ `${featured_seller.inspired_look_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '25px' }}>Inspired Look Thumbnail Image</h3>
            }
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='12' style={{  height: '30px', backgroundColor: 'gray' }}>
            <h3 className='text-center'>Footer</h3>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )

}

CmsFeaturedSellerFavouriteBrandPreviewSection.propTypes    = propTypes
CmsFeaturedSellerFavouriteBrandPreviewSection.defaultProps = defaultProps

export default CmsFeaturedSellerFavouriteBrandPreviewSection
